// pages/CompetencyQuiz/quizFormat.js — small display helpers shared by the quiz pages.
import React from "react";
import { Badge } from "reactstrap";
import { BAND_TONE } from "../../services/competencyQuizApi";

/** Server times carry a "Z" (UTC); show them in the viewer's local time. */
export const fmtDateTime = (iso) => {
    if (!iso) return "";
    const d = new Date(iso);
    if (Number.isNaN(d.getTime())) return String(iso);
    return d.toLocaleString(undefined, { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit" });
};

export const fmtPercent = (v) => (v === null || v === undefined || v === "" ? "—" : `${Number(v).toFixed(0)}%`);

/** mm:ss (or h:mm:ss) for the countdown. */
export const fmtClock = (seconds) => {
    const s = Math.max(0, Math.floor(seconds || 0));
    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = String(s % 60).padStart(2, "0");
    return h > 0 ? `${h}:${String(m).padStart(2, "0")}:${sec}` : `${m}:${sec}`;
};

export const BandBadge = ({ band }) =>
    band ? <Badge color={BAND_TONE[band] || "secondary"}>{band}</Badge> : <span className="text-muted">—</span>;
